<template>
  <div class="hello">
    <h1>Thanks</h1>
    We have received your contact request.  Expect to hear back soon!
  </div>
</template>

<script>
export default {
  name: 'Thanks',
  data () {
    return {
      msg: 'Welcome to Your Vue.js App'
    }
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
</style>



// WEBPACK FOOTER //
// src/views/Thanks.vue